module.exports = __webpack_public_path__ + "static/2006-d68c61cd015aa6c520271621dcb48712.webp";